if (!customElements.get('shipping-checkpoints')) {
  class ShippingCheckpoints extends HTMLElement {
    connectedCallback() {
      this.renderDates();
    }

    renderDates() {
      const days = this.parseLabels(this.dataset.dayLabels, 7);
      const months = this.parseLabels(this.dataset.monthLabels, 12);
      const dateFormat = this.dataset.dateFormat || 'dd_mm_no_dot';
      const today = new Date();

      today.setHours(12, 0, 0, 0);

      this.querySelectorAll('[data-shipping-date]').forEach((element) => {
        const minDays = this.parseDays(element.dataset.minDays);
        const maxDays = this.parseDays(element.dataset.maxDays);
        const startDate = this.addDays(today, minDays);
        const endDate = this.addDays(today, maxDays);
        const template = element.dataset.template || '';

        element.innerHTML = template
          .replaceAll('[start_date]', this.formatDate(startDate, dateFormat, days, months))
          .replaceAll('[end_date]', this.formatDate(endDate, dateFormat, days, months));
      });
    }

    parseLabels(value, expectedLength) {
      const labels = (value || '').split(',').map((label) => label.trim());
      return labels.length === expectedLength ? labels : [];
    }

    parseDays(value) {
      const days = Number.parseInt(value, 10);
      return Number.isFinite(days) ? Math.max(0, days) : 0;
    }

    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }

    ordinal(day) {
      if (day > 10 && day < 14) return 'th';
      if (day % 10 === 1) return 'st';
      if (day % 10 === 2) return 'nd';
      if (day % 10 === 3) return 'rd';
      return 'th';
    }

    formatDate(date, format, days, months) {
      const dayName = days[date.getDay() === 0 ? 6 : date.getDay() - 1] || '';
      const monthName = months[date.getMonth()] || '';
      const day = date.getDate();
      const numericDay = String(day).padStart(2, '0');
      const numericMonth = String(date.getMonth() + 1).padStart(2, '0');

      switch (format) {
        case 'day_mm_dd':
          return `${dayName}, ${monthName} ${day}${this.ordinal(day)}`;
        case 'day_dd_mm':
          return `${dayName}, ${day}. ${monthName}`;
        case 'mm_dd':
          return `${monthName} ${day}${this.ordinal(day)}`;
        case 'dd_mm':
          return `${day}. ${monthName}`;
        case 'day_dd_mm_numeric':
          return `${dayName}, ${numericDay}. ${numericMonth}.`;
        case 'dd_mm_numeric':
          return `${numericDay}. ${numericMonth}.`;
        case 'dd_mm_no_dot':
        default:
          return `${day} ${monthName}`;
      }
    }
  }

  customElements.define('shipping-checkpoints', ShippingCheckpoints);
}
